import { render, staticRenderFns } from "./BoAddCategory.vue?vue&type=template&id=fd2beef0&"
import script from "./BoAddCategory.vue?vue&type=script&lang=js&"
export * from "./BoAddCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports